<template>
  <search-layout class="policy-search" header="保单查询">
    <van-form :show-error-message="false" @submit="onSearch">
      <van-field
        clearable
        v-model="policyNo"
        name="policyNo"
        label="保单号"
        placeholder="请输入保单号"
        :rules="[{ required: true, message: '请输入保单号' }]"
      ></van-field>
      <van-field
        name="certTypeName"
        :value="certTypeName"
        label="证件类型"
        placeholder="请选择证件类型"
        readonly
        clickable
        is-link
        @click="showPicker = true"
        :rules="[
          { required: true, trigger: 'onChange', message: '请选择证件类型' },
        ]"
      />
      <van-field
        clearable
        v-model="certNo"
        name="certNo"
        label="证件号码"
        placeholder="请输入证件号码"
        :rules="[{ required: true, message: '请输入证件号码' }]"
      ></van-field>
      <div class="submit-action">
        <van-button class="submit-btn" block type="info" native-type="submit">
          查询
        </van-button>
      </div>
    </van-form>

    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        show-toolbar
        value-key="name"
        :columns="certTypes"
        @confirm="onPickerCert"
        @cancel="showPicker = false"
      />
    </van-popup>
  </search-layout>
</template>

<script>
import { Toast } from 'vant';
import SearchLayout from '@/layouts/SearchLayout';
import * as constants from '@/utils/constants';
import * as services from '@/services';
import * as utils from '@/utils';

export default {
  name: 'PolicySearch',
  components: {
    SearchLayout,
  },

  data() {
    return {
      certTypes: constants.CERT_TYPES,
      showPicker: false,
      policyNo: '',
      certType: '',
      certTypeName: '',
      certNo: '',
    };
  },

  methods: {
    onPickerCert(selected, index) {
      this.certTypeName = selected.name;
      this.certType = selected.value;
      this.showPicker = false;
    },

    onSearch(value) {
      const { policyNo, certType, certNo } = this;

      Toast.loading({
        message: '正在查询',
        forbidClick: true,
        duration: 0,
      });

      services.getPolicy(policyNo, certType, certNo).then(res => {
        const query = { policyNo, certType, certNo };
        this.$router.push({ name: 'policy-detail', query });
        Toast.clear();
      });
    },
  },
};
</script>

<style lang="less">
.policy-search {
  .submit-action {
    margin: 12px 16px;
  }
}
</style>
